import React from 'react';
import { FontIcon } from 'material-ui';
import getClassNames from 'classnames';
import Counter from '../../tc-ui/counter';


const LeftNavWidget = ({ data, name, iconClassName, routeName, onTouchTap, filteredState, counterStyle, style }) => {
  const classes = getClassNames('nav-link', 'contracting-left-nav-widget-link', {
    'is-active': name === filteredState || routeName === (window.location || {}).pathname,
  });
  const iconNode = iconClassName ? <FontIcon className={iconClassName} color="none" /> : undefined;
  const nameNodeClass = iconClassName ? 'content-with-icon' : 'content-without-icon';
  const counterNode = !isNaN(data) ? <Counter style={counterStyle} data={data} /> : undefined;
  return (
    <div className="contracting-left-nav-widget">
      {
        onTouchTap ? (
          <div
            className={classes}
            onClick={onTouchTap}
            style={style}
          >
            {iconNode}
            <span className={nameNodeClass}>{name}</span>
            {counterNode}
          </div>
        ) : <div className="contracting-left-nav-title">{name}</div>
      }
    </div>
  );
};
LeftNavWidget.propTypes = {
  routeName: React.PropTypes.string,
  name: React.PropTypes.any,
  iconClassName: React.PropTypes.string,
  data: React.PropTypes.number,
  onTouchTap: React.PropTypes.func,
  filteredState: React.PropTypes.string,
  counterStyle: React.PropTypes.object,
};
export default LeftNavWidget;



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/left-nav-widget.jsx